import axios from 'axios'
import {push} from "connected-react-router";
import {API_PRODUCT_INFO} from "../constants/api";
import {START, SAVE_DESIGN, SUCCESS, FAIL} from "../constants/action-types";
import Mediator from "../services/Mediator";
import trackEvent from "../../../utils/track-event";
import {
  saveDesignToLocalStorage,
  clearDesignFromLocalStorage
} from "../services/lib/save-design";

export const getURLforPushInHistory = ({product: {closeup}}) => {
  return `${closeup}/edit_v2`;
};

const getDataForSavingFromState = (state) => {
  const {product, condition, designs} = state;
  /* eslint-disable camelcase */
  const body = {
    authenticity_token: state.authenticityToken,
    [product.meta.product]: {
      ...product.meta.designs.reduce((acc, design, i) => {
        if (designs[i]) {
          return {
            ...acc,
            [`${design.side}_design_canvas_data`]: JSON.stringify(
              designs[i].design
            )
          };
        }
        return acc;
      }, {}),
      ...Object.keys(condition.variants).reduce((acc, variantKey) => {
        return {
          ...acc,
          [`${
            variantKey === `color` ? `default_${variantKey}` : variantKey
          }`]: condition.variants[variantKey]
        };
      }, {}),
      product_attributes: {
        id: product.id,
        psignature: product.psignature,
        raw_parent_id: product.raw_parent_id
      }
    }
  };
  return JSON.stringify(body);
  /* eslint-enable camelcase */
};

const getURLforCallAPI = ({
  product: {
    id,
    closeup,
    meta: {pluralized_product: name}
  },
  mobileApp
}) =>
  `${mobileApp ? `/mobile` : API_PRODUCT_INFO}/${name}${
    id ? `/${closeup.split(`/`).slice(-1)[0]}` : ``
  }`;

export const saveDesignRequest = (dispatch, getState) => {
  const {
    product: {
      id,
      meta: {product}
    },
    designs,
    mobileApp
  } = getState();
  dispatch({
    type: SAVE_DESIGN + START
  });

  const authHeader = mobileApp ? window.authHeaders : {};

  return axios({
    url: getURLforCallAPI(getState()),
    method: id ? `PATCH` : `POST`,
    headers: {
      "Accept": `application/json`,
      "Content-Type": `application/json`,
      ...authHeader
    },
    data: getDataForSavingFromState(getState())
  })
    .then(({ data, status, statusText }) => {
      if (status >= 400) {
        throw new Error(statusText);
      }

      // change url
      if (data.product.id) {
        dispatch({
          type: SAVE_DESIGN + SUCCESS,
          response: data
        });
        Mediator.isDesignSaved = true;
        Mediator.exitTextEditing(data.condition.design);

        if (/edit_v2/.test(window.location.href) === false && !Mediator.isDesignSaved) {
          dispatch(push(getURLforPushInHistory(getState())));
        }

        clearDesignFromLocalStorage(product, id);
        trackEvent({
          category: `Editor`,
          action: `Save design`
        });
        return data;
      } else {
        throw new Error(`Ошибка сохранения`);
      }
    })
    .catch((error) => {
      dispatch({
        type: SAVE_DESIGN + FAIL,
        error
      });
      saveDesignToLocalStorage(product, id, designs);
      throw error;
    });
};

export const saveDesign = () => {
  return (dispatch, getState) => {
    saveDesignRequest(dispatch, getState);
  };
};
